import { render, staticRenderFns } from "./signlist.vue?vue&type=template&id=3636b652&"
import script from "./signlist.vue?vue&type=script&lang=js&"
export * from "./signlist.vue?vue&type=script&lang=js&"
import style0 from "./signlist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports